export default function SocialRedditOutline() {
  return (
    <div
      className="ion-icon-social-reddit-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<circle cx="322.3" cy="288.4" r="31.8"/>
	<circle cx="190.3" cy="288.4" r="31.8"/>
	<g>
		<path d="M480.5,251c0-27.7-22.2-50.2-49.5-50.2c-13,0-24.7,5-33.6,13.3c-33.2-23.4-78.4-38.5-128.7-40.7L292,95.7l69.6,13.9
			c0.2,24.7,20.1,44.7,44.5,44.7c24.6,0,44.5-20.2,44.5-45.1S430.7,64,406.1,64c-18.6,0-34.5,11.6-41.2,28l-85.2-17l-29.4,98.2
			l-7.1,0.2c-50.3,2.2-95.5,17.4-128.7,40.7c-8.8-8.3-20.6-13.3-33.6-13.3c-27.3,0-49.5,22.5-49.5,50.2c0,19.6,11,36.5,27.1,44.8
			c-0.8,4.9-1.2,9.8-1.2,14.8C57.5,386.4,146.4,448,256,448s198.5-61.6,198.5-137.5c0-5-0.4-9.9-1.1-14.8
			C469.5,287.4,480.5,270.5,480.5,251z M406.1,81.9c14.8,0,26.8,12.2,26.8,27.2c0,15-12,27.2-26.8,27.2c-14.8,0-26.8-12.2-26.8-27.2
			C379.3,94.1,391.3,81.9,406.1,81.9z M49.2,251c0-17.8,14.3-32.2,31.8-32.2c7.2,0,13.9,2.5,19.2,6.6c-17.3,15.2-30.1,33-37,52.4
			C54.8,271.9,49.2,262.1,49.2,251z M386.4,392.9c-34.6,23.9-80.9,37.1-130.4,37.1s-95.8-13.2-130.4-37.1
			c-32.5-22.5-50.4-51.8-50.4-82.4c0-3.2,0.2-6.5,0.6-9.7c0.7-6,2.2-11.9,4.3-17.7c5.6-15.6,16-30.3,30.7-43.4
			c4.4-3.9,9.2-7.7,14.4-11.3c0.1-0.1,0.3-0.2,0.4-0.3C160.2,204.2,206.5,191,256,191c49.5,0,95.8,13.2,130.4,37.1
			c0.1,0.1,0.3,0.2,0.4,0.3c5.2,3.6,10,7.4,14.4,11.3c14.7,13.1,25.1,27.8,30.7,43.4c2.1,5.8,3.5,11.7,4.3,17.7
			c0.4,3.2,0.6,6.4,0.6,9.7C436.8,341.1,418.9,370.4,386.4,392.9z M448.8,277.7c-6.9-19.4-19.7-37.2-37-52.4
			c5.3-4.1,12-6.6,19.2-6.6c17.5,0,31.8,14.5,31.8,32.2C462.8,262.1,457.2,271.9,448.8,277.7z"/>
		<path d="M320.5,357.9c-0.2,0.2-24.2,24.2-64.5,24.4c-40.9-0.2-64.4-24.2-64.6-24.4l-12.6,12.4c1.2,1.2,29.6,29.5,77.2,29.7
			c47.6-0.2,75.9-28.5,77.1-29.7L320.5,357.9z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
